import { getToken } from './Token';

export async function createGroup(Properties, accessToken=undefined) {
    let token = accessToken ? accessToken : await getToken();
    let request = await fetch('https://graph.microsoft.com/v1.0/groups', {
        method: 'POST',
        headers: {   
            'Content-Type': 'application/json',
            'Content-length': '244',         
            'Authorization': token
        },
        body: JSON.stringify(Properties)  
    })
    let result = await request.json()
    return result
}

export async function getUserFromAD(userPrincipalName, accessToken = undefined) {
    let token = accessToken ? accessToken : await getToken();

    let request = await fetch(`https://graph.microsoft.com/v1.0/users?$filter=startswith(userPrincipalName, '${userPrincipalName}')`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": token
        }
    });

    let response = await request.json();

    return response;
}

export async function getGroupMembers(groupId, accessToken=undefined) {
    let token = accessToken ? accessToken : await getToken();
    
    let request = await fetch(`https://graph.microsoft.com/v1.0/groups/${groupId}/members`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": token
        }
    });

    let response = await request.json();

    return response;
}

export async function getGroupsOfUser(userId, accessToken=undefined) {
    let token = accessToken ? accessToken : await getToken();

    let request = await fetch(`https://graph.microsoft.com/v1.0/users/${userId}/memberOf`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": token
        }
    });

    let response = await request.json();

    return response;
}

export async function getOrganisationADGroup(orgId, accessToken = undefined) {
    let token = accessToken ? accessToken : await getToken();

    let request = await fetch(`https://graph.microsoft.com/v1.0/groups?$filter=startswith(displayName, 'Org_${orgId}')`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": token
        }
    });

    let response = await request.json();

    return response;
}

export async function getCurrentLoggedInUser(token = undefined) {
    let accessToken = token ? token : await getToken();
    let request = await fetch("https://graph.microsoft.com/v1.0/me", {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": accessToken
        }
    })
}

export async function getUserAccessLevel(userId, orgId) {
    
    let getAccessLevelRequest = await fetch(process.env.REACT_APP_DESIGNER_API_URL + "/api/v0/getUserAccessLevel/" + userId + "/" + orgId);
    let relationship = await getAccessLevelRequest.json();
    let { accessLevel } = relationship[0];
    return accessLevel;
}


export async function getUsersofprojects(projectName,projectId){
    let accessToken = await getToken();
    let Url = `https://graph.microsoft.com/v1.0/groups?$filter=startswith(displayName,'${projectName}_Administrator_${projectId}')`;

    let projecRequest = await fetch(Url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': accessToken
        }
    })
	let projectResult = await projecRequest.json()
    projectResult = projectResult.value[0]
    if(projectResult.description.includes("ProjectGroup")){
         
        let usersRequest = await fetch('https://graph.microsoft.com/v1.0/groups/'+projectResult.id+'/members', {
    		method: 'GET',
    		headers: {
        		'Content-Type': 'application/json',
        		'Authorization': accessToken
      		}
  		})
		let usersResult = await usersRequest.json()
        let users = [] ;
        for (let user of usersResult.value) {
            if (user["@odata.type"] === "#microsoft.graph.user") {
				user.type="Administrator"
				users.push(user);
			}
			if (user["@odata.type"] === "#microsoft.graph.group") {
                           
				if(user.description.includes("ContributorGroup")){
					let subUsers = await getSubMembers(user.id,"Contributor",accessToken)
                    if(subUsers.value.length > 0){
                        users = [...users,...subUsers.value]
                    }
                    
                }
				if(user.description.includes("CollaboratorGroup")){
					let subUsers = await getSubMembers(user.id,"Collaborator",accessToken)
                    if(subUsers.value.length > 0){
                        users = [...users,...subUsers.value]
                    }
				}              
			}
        }
        for ( let user of users ) {
            user.fullName = user.givenName + " " + user.surname;
        }
        
        return users;      
    }
    else{
        return false
    }
}

export async function getSubMembers(id,type,accessToken) {
    let subUserRequest = await fetch('https://graph.microsoft.com/v1.0/groups/'+id+'/members', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': accessToken
        }
    })
	let subUserResult = await subUserRequest.json()
    return subUserResult;
}

export async function UpdateUser(user) {
    let token = await getToken();
    
    await fetch("https://graph.microsoft.com/v1.0/users/"+ user.Id,{
        method:"PATCH",
        headers:{
            Authorization:"Bearer " + token,
            "Content-Type":"application/json"
        },
        body:JSON.stringify({
            givenName:user.firstName,
            surname:user.lastName,
            displayName: user.displayName,
            jobTitle:user.jobTitle
        })
    })
}